import { Injectable , Inject} from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class LanguagesService extends APIService{
  constructor(http: HttpClient,router :Router) {
    super(http)
    this.endPoint = "languages"
  }
  
  getAll(){
    return this.http.get(this.url,this.httpOptions)
  }

  get(id){
  	return this.http.get(this.url+`/${id}`,this.httpOptions)
	}

  add(record){
    return this.http.post(this.url,record,this.httpOptions)
  }

  update(record,id){
    return this.http.put(this.url+`/${id}`,record,this.httpOptions);
  }

  delete(id){
    return this.http.delete(this.url+`/${id}`,this.httpOptions);
  }
}
